<ng-template #modalCart let-c="close" let-d="dismiss">
  <wsb-modal
    primaryButtonText="{{ 'common_close' | translate }}"
    (primary)="d()"
    (dismiss)="d()"
    title="{{ 'shop_history_detail_modal' | translate }}"
  >
    <div body>
      <table class="table">
        <thead>
          <tr>
            <th translate>common_description</th>
            <th translate>shop_cart_quantity</th>
            <th translate>shop_cart_unit_price</th>
            <th translate>shop_subscription_totalprice</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let cartItem of cartToView.shopCartItems">
            <td translate="">{{ replaceLabelTagWithValue(cartItem) }}</td>
            <td>{{ cartItem.quantity }}</td>
            <td class="text-end">{{ getCurrencySymbol() + ' ' + cartItem.shopItem.price }}</td>
            <td class="text-end">{{ getCurrencySymbol() + ' ' + cartItem.totalPriceItem }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr *ngIf="cartToView.vatPercent">
            <td colspan="3" translate>shop_cart_vat</td>
            <td class="text-end">{{ getCurrencySymbol() + ' ' + cartToView.vat }}</td>
          </tr>
          <tr>
            <td colspan="3" translate>shop_cart_grandtotal</td>
            <td class="text-end">{{ getCurrencySymbol() + ' ' + cartToView.totalPriceToPay }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </wsb-modal>
</ng-template>

<ng-template #modalDelete let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="modalDeleteForm()"
    (dismiss)="d()"
    cancelButtonEnable="true"
    title="{{ 'common_attention' | translate }}"
    text="{{ 'shop_history_cart_delete_confirm' | translate }}"
  ></wsb-modal>
</ng-template>

<h3 class="my-5" translate>billing_tab_invoices</h3>
<div class="my-5">
  <wsb-atlas-grid
    *ngIf="tableInvoicesGridOptions"
    #gridInvoices
    class="atlas-grid-simplest"
    class="mt-2"
    [loading]="tableInvoicesLoading"
    [columnDefs]="tableInvoicesColumnDefs"
    [@gridIsLoaded]="gridAnimationState"
    [options]="tableInvoicesGridOptions"
    [components]="components"
  ></wsb-atlas-grid>
</div>
